import styled from 'styled-components';

export default styled.div`
  opacity: 0.2;
  border-top: 2px dashed #000000;
`;
